export default {
    Positive: 'positive',
    Negative: 'negative',
    Warning: 'warning',
    Info: 'info',
};
